import React, { useState } from 'react'
import ReactTable from 'react-table'
import { Link } from 'react-router-dom'
import { useQuery } from '@apollo/react-hooks'
import _ from 'lodash'
import {
  Div, Button, Icon, Input, H3, DynamicButtonLink, Loading,
  H4,
} from 'konsys-ui'
import { theme } from '../../../styles/_variables'
import { Wrapper } from '../../../components/suppliers-components'
import {
  WAREHOUSES, SUPPLIERS, CATEGORIES, BRANDS, INVENTORIES,
} from '../../../constants/graph/query'
import { ListContainer, Select } from '../../../components/common'
import { PAYMENT_TYPE } from '../constants'
import './style-css.css'
import PERMISSION from '../../../constants/permissions'
import config from './config'

const { color } = theme

const Index = () => (
  <Div display='flex' flexDirection='column'>
    <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
      <H3 bold color={color.primaryColor} margin='32px 0'>สต๊อกสินค้า</H3>
      <Div display='flex' flexDirection='row' justifyContent='space-between'>
        <DynamicButtonLink link='/inventory/add' condition={_.includes(window.perms, PERMISSION.CREATE_INVENTORY)} props={{ text: 'เพิ่มสินค้า' }}/>
      </Div>
    </Div>
    <List/>
  </Div>
)

export const List = () => {
  const [current, setCurrent] = useState(0)
  const [variable, setVariable] = useState({})
  const {
    data, loading, error, fetchMore, refetch,
  } = useQuery(INVENTORIES, {
    variables: {
      ...variable,
      limit: 5,
      offset: 5 * current,
    },
  })
  return (
    <Wrapper overflow padding='0 0 40px 0'>
      { loading && _.isEmpty(data) && <Loading center='true' />}
      {
        (!_.isNil(data))
        && (
          <h4 className='text-base'>สินค้าทั้งหมด: <span style={{ color: color.primaryColor, fontWeight: 700 }}>{data.inventoryList.data.totalCount}</span></h4>
        )
      }
      {
        (!_.isNil(data))
        && (
          <h4 className='text-base'>สินค้าที่มีจำนวนต่ำกว่าสต๊อกขั้นต่ำ: <span style={{ color: color.primaryColor, fontWeight: 700 }}>{data.inventoryList.data.lowStockCount}</span></h4>
        )
      }
      { (!loading || !_.isEmpty(data))
        && <Div>
            <ReactTable
              className='table'
              data={data.inventoryList.data.list} // *
              resizable={false}
              columns={config.columns} // *
              minRows={5}
              manual
              // defaultPageSize={10}
              showPageSizeOptions={false}
              getTdProps={() => ({ disabled: true })} // *
              getTrProps={(state, rowInfo) => { // *
                if (rowInfo) {
                  const stock = _.sumBy(rowInfo.original.inventoryOptions[0].stockLocation, location => location.quantity)
                  const minimumStock = rowInfo.original.inventoryOptions[0].minimumStock || 0
                  const isLowStock = stock < minimumStock
                  return {
                    style: {
                      padding: '8px 0',
                      backgroundColor: isLowStock ? `rgba(${color.primaryColorRGB}, 0.3)` : '#ffffff',
                      borderLeft: `3px solid ${color.primaryColor}`,
                    },
                  }
                } return {}
              }}
              previousText='ก่อนหน้า'
              nextText='ถัดไป'
              pageText='หน้า'
              ofText='จาก'
              page={current}
            pages={Math.ceil(data.inventoryList.data.totalFilter / 5)}
              onPageChange={page => setCurrent(page)}
              onFilteredChange={async (newFiltered) => {
                const newOjb = {
                  sku: '',
                  productName: '',
                  brand: '',
                  supplierName: '',
                  category: '',
                  productGroup: 'ALL',
                  lowStock: false,
                }
                await newFiltered.forEach((v) => {
                  if (v.id === 'inventoryOptions.variantName') {
                    Object.assign(newOjb, { variantName: v.value })
                  } else if (v.id === 'supplier[0].name') {
                    Object.assign(newOjb, { supplierName: v.value })
                  } else if (v.id === 'stockSummary') {
                    Object.assign(newOjb, { lowStock: v.value })
                  } else {
                    Object.assign(newOjb, { [v.id]: v.value })
                  }
                })
                setCurrent(0)
                refetch(newOjb)
                setVariable(newOjb)
              }}
              onSortedChange={async (newSorted) => {
                setCurrent(0)
                refetch({
                  orderBy: newSorted[0].desc ? 'DESC' : 'ASC',
                  orderField: newSorted[0].id,
                })
              }}
            />
            {
              loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
            }
        </Div>
      }
    </Wrapper>
  )
}

export default Index
